import { useMemo } from "react";
import { useWatch } from "react-hook-form";
import { BaselineIcon } from "../../../../Icons";
import LayerIcon from "../../../../Icons/LayerIcon";
import { UpdateType } from "../../EditorContextProvider";
import { EditType } from "../../EditorSwiper/EditorSwiper";
import { getFeatureNameField } from "../../helpers";
import { PlatformIconHolder } from "../../Platform/Platform-styled";

const LayerHeader = ({
  editableLayer,
  editType,
  updateType,
  t,
  config,
  activeColor,
  batchUpdateFeatures,
  defaultTitle = "",
  showIcon,
}) => {
  const nameField = useMemo(
    () => getFeatureNameField(editableLayer),
    [editableLayer]
  );

  const value = useWatch({ name: nameField }) || null;

  const progressTitle = useMemo(() => {
    if (editType === EditType.create) {
      return t("screen.widget.Editor.manager.header.adding");
    } else {
      if (updateType === UpdateType.baseline) {
        if (editableLayer) {
          return t("screen.widget.Editor.manager.header.editing");
        } else {
          return t("screen.widget.Editor.manager.baseline.workOnDataset");
        }
      } else if (updateType === UpdateType.situational) {
        return t("screen.widget.Editor.manager.header.updating");
      }
    }
  }, [updateType, editType, editableLayer]);

  const title = useMemo(() => {
    if (defaultTitle) {
      return defaultTitle;
    }

    if (value != null && typeof value === "string") {
      return value;
    } else if (editableLayer) {
      return `${editableLayer.getLayerTitle(t)} ${
        batchUpdateFeatures.length > 0 ? `(${batchUpdateFeatures.length})` : ""
      }`;
    }

    return defaultTitle;
  }, [value, editableLayer, batchUpdateFeatures, defaultTitle, t]);

  if (editableLayer) {
    return (
      <>
        {showIcon && (
          <LayerIcon
            t={t}
            layer={editableLayer}
            config={config}
            width={34}
            height={34}
            opsColor={activeColor}
            textColor="#fff"
            wrapperStyles={{
              background: activeColor,
              borderRadius: 100,
              overflow: "hidden",
              minWidth: 34,
            }}
            textStyles={{
              background: activeColor,
              borderRadius: 100,
              height: 34,
              width: 34,
              minWidth: 34,
            }}
            selected
          />
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 4,
          }}
        >
          <p
            style={{
              width: "auto",
              fontSize: 16,
              textAlign: "left",
              color: "var(--fontColor)",
            }}
          >
            {title}
          </p>
        </div>
      </>
    );
  } else {
    return (
      <>
        <PlatformIconHolder color="transparent">
          <BaselineIcon fill="rgb(73, 73, 73)" />
        </PlatformIconHolder>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 4,
          }}
        >
          <p
            style={{
              width: "auto",
              fontSize: 16,
              textAlign: "left",
              color: "var(--fontColor)",
            }}
          >
            {progressTitle}
          </p>
        </div>
      </>
    );
  }
};

export default LayerHeader;
